import React, { useEffect, useRef } from 'react';
import { reverse } from 'named-urls';
import routes from '@achievable-me/tundra-wizard/routes';
import ProductLayout from '$components/layout/ProductLayout';
import Progress from '$components/ProductDashboard/Progress';
import QuoteOfTheMoment from '$components/ProductDashboard/QuoteOfTheMoment';
import UpcomingWorkload from '$components/ProductDashboard/UpcomingWorkload';
import ExamReadiness from '$components/ProductDashboard/ExamReadiness';
import SetActiveProduct from '$components/ProductDashboard/SetActiveProduct';
import Well from '$components/ProductDashboard/Well';
import ScrollToTop from '$components/library/ScrollToTop';
import Seo from '$components/Seo';
import { useTrack } from '$lib/tracking';
import { checkProductSlug } from '$lib/checkProductSlug';
import DashboardExtra from './DashboardExtra';
import Welcome from './Welcome';
import styles from './styles.scss';

const ProductDashboardContent = (props) => {
  const { currentUser, product, flatContent, inflatedContent } = props;
  const { uuid: userUuid } = currentUser;
  const { slug: productSlug } = product;
  const { isFinra } = checkProductSlug(productSlug);
  useTrack('Dashboard | Viewed', { productSlug });
  const layoutRef = useRef();

  return (
    <ScrollToTop elementRef={layoutRef}>
      <Seo
        title={`${product.name} dashboard`}
        canonical={reverse(routes.study.dashboard, { productSlug: product.slug })}
        description={`Study, track your progress, and pass the ${product.name}.`}
      />
      <div ref={layoutRef} className={styles.layout}>
        <div className={styles.pad} />
        <Welcome currentUser={currentUser} product={product} />
        <SetActiveProduct product={product} currentUser={currentUser} />
        {isFinra && (
          <ExamReadiness productSlug={product.slug} productUuid={product.uuid} />
        )}
        <Progress
          flatContent={flatContent}
          inflatedContent={inflatedContent}
          product={product}
        />
        <DashboardExtra currentUser={currentUser} product={product} />
        <div className={styles.secondaryContent}>
          <Well>
            <div className={styles.blocksContainer}>
              <div className={styles.block}>
                <QuoteOfTheMoment productSlug={product.slug} />
              </div>
              <div className={styles.block}>
                <UpcomingWorkload product={product} />
              </div>
            </div>
          </Well>
        </div>
      </div>
    </ScrollToTop>
  );
};

const ProductDashboard = (props) => {
  const { currentUser, location, match } = props;

  return (
    <ProductLayout currentUser={currentUser} location={location} match={match}>
      {({ flatContent, inflatedContent, product }) => (
        <ProductDashboardContent
          currentUser={currentUser}
          product={product}
          flatContent={flatContent}
          inflatedContent={inflatedContent}
        />
      )}
    </ProductLayout>
  );
};

export default ProductDashboard;
